module.exports = __webpack_public_path__ + "static/media/IMG_6399.cf0e19b5.jpg";